import { render, staticRenderFns } from "./open-account-mt45.vue?vue&type=template&id=6c8913b8&scoped=true"
import script from "./open-account-mt45.vue?vue&type=script&lang=js"
export * from "./open-account-mt45.vue?vue&type=script&lang=js"
import style0 from "./open-account-mt45.vue?vue&type=style&index=0&id=6c8913b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8913b8",
  null
  
)

export default component.exports